/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reload_ProxyInputs */

const en_reload_proxy = /** @type {(inputs: Reload_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload Proxy`)
};

const fr_reload_proxy = /** @type {(inputs: Reload_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recharger le proxy`)
};

const de_reload_proxy = /** @type {(inputs: Reload_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy neu laden`)
};

const it_reload_proxy = /** @type {(inputs: Reload_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricarica proxy`)
};

const ru_reload_proxy = /** @type {(inputs: Reload_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перезагрузить прокси`)
};

const es_reload_proxy = /** @type {(inputs: Reload_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recargar proxy`)
};

const zh_cn2_reload_proxy = /** @type {(inputs: Reload_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新加载代理`)
};

const ja_reload_proxy = /** @type {(inputs: Reload_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロキシをリロード`)
};

const hi_reload_proxy = /** @type {(inputs: Reload_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रॉक्सी को पुनः लोड करें`)
};

const pt_pt2_reload_proxy = /** @type {(inputs: Reload_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recarregar proxy`)
};

/**
* | output |
* | --- |
* | "Reload Proxy" |
*
* @param {Reload_ProxyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const reload_proxy = /** @type {((inputs?: Reload_ProxyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reload_ProxyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_reload_proxy(inputs)
	if (locale === "de") return de_reload_proxy(inputs)
	if (locale === "it") return it_reload_proxy(inputs)
	if (locale === "ru") return ru_reload_proxy(inputs)
	if (locale === "es") return es_reload_proxy(inputs)
	if (locale === "zh-CN") return zh_cn2_reload_proxy(inputs)
	if (locale === "ja") return ja_reload_proxy(inputs)
	if (locale === "hi") return hi_reload_proxy(inputs)
	if (locale === "pt-PT") return pt_pt2_reload_proxy(inputs)
	return en_reload_proxy(inputs)
});